import { getBiodata } from "@/services/getData"
import { DataSiswa } from "@/types"
import { useQuery } from "@tanstack/react-query"
import useSessionStorage from "./useSessionStorage"
import { useUser } from "./useUser"

export default function useDataPendaftaran() {
  // const [searchParams] = useSearchParams();
  // const sessionPeriode?.id_sys_periode = searchParams.get("periode");

  const [sessionPeriode] = useSessionStorage("sessionPeriode", {
    id_sys_periode: "",
  })

  const { user } = useUser()

  const {
    data: dataSiswa,
    isPending: isPendingDataSiswa,
    isFetched,
  } = useQuery<DataSiswa>({
    queryKey: ["dataBiodata", user?.id, sessionPeriode?.id_sys_periode],
    queryFn: () => getBiodata(sessionPeriode?.id_sys_periode || ""),
    enabled: !!user?.id && !!sessionPeriode?.id_sys_periode,
  })

  const dataPendaftaran = dataSiswa ? dataSiswa?.data_pendaftaran?.[0] : null
  const isValidPendaftaran = dataPendaftaran?.is_valid_pendaftaran === 1

  return {
    isFetched,
    dataSiswa,
    dataPendaftaran,
    isValidPendaftaran,
    isPendingDataSiswa,
  }
}
